// openApproval.js
import axios from 'axios'

export default function openApproval(id, swal, getAllDataPass, setLoading) {
  swal({
    title: 'Are you sure?',
    text: 'Do you agree to schedule?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, proceed',
    cancelButtonText: 'No, cancel',
  }).then(result => {
    setLoading(true)

    if (result.isConfirmed) {
      axios
        .put(`employee-schedule/${id}/approve`, { remark: '' })
        .then(res => {
          if (res.status === 200) {
            swal('Approved!', 'Approve Successfully.', 'success')
            getAllDataPass(1)
          }
        })
        .catch(() => {
          swal('Error!', 'There was an issue with the approval.', 'error')
        })
        .finally(() => {
          setLoading(false)
        })
    } else if (result.dismiss === 'cancel') {
      swal({
        title: 'Provide a remark',
        input: 'text',
        inputPlaceholder: 'Enter your reason for rejection...',
        showCancelButton: true,
        confirmButtonText: 'Submit',
        cancelButtonText: 'Cancel',
      }).then(inputResult => {
        if (inputResult.isConfirmed) {
          setLoading(true)
          axios
            .put(`employee-schedule/${id}/reject`, {
              remark: inputResult.value || '',
            })
            .then(() => {
              swal('Disapproved!', 'Disapproved Successfully.', 'success')
              getAllDataPass(1)
            })
            .catch(() => {
              swal(
                'Error!',
                'There was an issue with the disapproval.',
                'error',
              )
            })
            .finally(() => {
              setLoading(false)
            })
        }
      })
    }
  })
}
